export const APICONSTANTS = {
  PROVIDERS: '/vh-providers',
  ASSOCIATED_BUNDLES: '/network/providers/:providerCode/bundles',
  BUNDLES: '/vh-bundles',
  NETWORK_OFFERINGS: '/network/providers/search',
  NETWORKS: '/vh-networks',
  CATEGORIES: '/network/providers/bundles/categories',
  FACILITY_PHYSICIANS: '/network/providers/:facilityCode/associated-physicians',
  PHYSICIAN_FACILITIES: '/network/providers/:physicianCode/associated-facilities',
  EXPORT_PROVIDERS: '/network/provider-directory/providers/export',
  EXPORT_PROVIDER_FACILITY_REPORT: '/utility/export/provider-facility-report-pdf',
};
